// This file is generated by Sapper — do not edit it!
export { default as Root } from '../../../routes/_layout.svelte';
export { preload as root_preload } from './shared';
export { default as ErrorComponent } from '../../../routes/_error.svelte';

export const ignore = [/^\/practice.json$/, /^\/practice\/([^\/]+?).json$/];

export const components = [
	{
		js: () => import("../../../routes/index.svelte"),
		css: ["index.1b39c741.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/services.svelte.html"),
		css: ["services.svelte.cfe6534e.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/prais-list.svelte"),
		css: ["prais-list.afc9f331.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/contacts.svelte"),
		css: ["chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/practice/index.svelte"),
		css: ["index.06eeddb0.css","chunk.d3e269cd.css","chunk.56ea30aa.css"]
	},
	{
		js: () => import("../../../routes/practice/[slug].svelte"),
		css: ["[slug].0c371fda.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/services.svelte"),
		css: ["chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/settings.svelte"),
		css: ["settings.e6dcef60.css"]
	},
	{
		js: () => import("../../../routes/about.svelte"),
		css: ["about.15fe3b75.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/admin.svelte"),
		css: ["admin.450d6584.css","chunk.d3e269cd.css"]
	},
	{
		js: () => import("../../../routes/blog/index.svelte"),
		css: ["chunk.d3e269cd.css","chunk.56ea30aa.css"]
	},
	{
		js: () => import("../../../routes/blog/[slug].svelte"),
		css: ["[slug].ac389661.css","chunk.d3e269cd.css"]
	}
];

export const routes = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// services.svelte.html
		pattern: /^\/services.svelte\/?$/,
		parts: [
			{ i: 1 }
		]
	},

	{
		// prais-list.svelte
		pattern: /^\/prais-list\/?$/,
		parts: [
			{ i: 2 }
		]
	},

	{
		// contacts.svelte
		pattern: /^\/contacts\/?$/,
		parts: [
			{ i: 3 }
		]
	},

	{
		// practice/index.svelte
		pattern: /^\/practice\/?$/,
		parts: [
			{ i: 4 }
		]
	},

	{
		// practice/[slug].svelte
		pattern: /^\/practice\/([^\/]+?)\/?$/,
		parts: [
			null,
			{ i: 5, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// services.svelte
		pattern: /^\/services\/?$/,
		parts: [
			{ i: 6 }
		]
	},

	{
		// settings.svelte
		pattern: /^\/settings\/?$/,
		parts: [
			{ i: 7 }
		]
	},

	{
		// about.svelte
		pattern: /^\/about\/?$/,
		parts: [
			{ i: 8 }
		]
	},

	{
		// admin.svelte
		pattern: /^\/admin\/?$/,
		parts: [
			{ i: 9 }
		]
	},

	{
		// blog/index.svelte
		pattern: /^\/blog\/?$/,
		parts: [
			{ i: 10 }
		]
	},

	{
		// blog/[slug].svelte
		pattern: /^\/blog\/([^\/]+?)\/?$/,
		parts: [
			null,
			{ i: 11, params: match => ({ slug: d(match[1]) }) }
		]
	}
])(decodeURIComponent);